import React from 'react'
import {BorderLeft, TextCenter} from 'react-bootstrap-icons';
import {Link} from 'react-router-dom'
import {
    Button,
    Card,
    CardHeader,
    CardTitle,
    CardBody,
    Row,
    Col,
    ListGroup,
    ListGroupItem,
    Table
} from "reactstrap";
import axios from "axios";
import {saveAs} from "file-saver";
import {GET_EXCEL_TEMPLATE} from "../../actions/actions";
import Advantages from 'components/mainPageComponents/Advantages'
import UnusedViews from 'components/mainPageComponents/UnusedViews'

const MainPage = () => {
    const [view, setView] = React.useState('main')

    const getBackBtn = () => {
        return (
            <Button className="btn-round" outline color="primary" onClick={() => {
                window.focus();
                window.scrollTo(0, 0);
                setView('main');
            }} style={btnNewStyle}> Powrót </Button>
        )
    }

    React.useEffect(() => {
        // window.scrollTo(0, 0);
        document.getElementById('topPage').scrollIntoView();
    }, [view])


    const downloadGuide = async () =>{
        const config = {
        responseType: 'arraybuffer',
        headers: {
            'Content-Type': 'pdf',

        },
    };
    try {

        const res = await axios.get(process.env.REACT_APP_GET_GUIDE, config);
        let blob = new Blob([res.data], {
              type: 'application/pdf',
            });
        saveAs(blob, 'instrukcja.pdf');

    } catch (err) {
        console.log("error: ", JSON.stringify(err))
    }
    }
    const openDemo = () => {
        window.open('https://www.youtube.com/watch?v=q6lXrYGO0EA', '_blank')
    }

    return (
        <div className="content" id='topPage'>
            <Row>
                <Col className="ml-auto mr-auto" md="12">
                    {view === 'main' && <>
                        <Card>
                            <CardHeader>
                                <CardTitle tag="h2" className={'h5'}>
                                    Aplikacja SRK – najprostszy sposób zarządzania podmiotem leczniczym
                                </CardTitle>
                            </CardHeader>
                            <CardBody style={{border: "0px"}}>
                                <ListGroup style={{textAlign: 'justify', border: "0px"}}>
                                    <ListGroupItem style={{"border": '0px', lineHeight:"1.7"}}>Aplikacja SRK to &nbsp;narzędzie
                                        umożliwiające rozliczenie kosztów zgodnie z&nbsp;zapisami rozporządzenia&nbsp;MZ z&nbsp;dnia 
                                        26&nbsp;października 2020&nbsp;r. w&nbsp;sprawie zaleceń dotyczących standardu rachunku 
                                        kosztów u&nbsp;świadczeniodawców (Dz.U. z&nbsp;2020&nbsp;r., poz.&nbsp;2045).<br/>
                                    Zyskujecie Państwo dostęp do&nbsp;bezpłatnego narzędzia, 
                                        które poprzez przejrzystą prezentację wprowadzonych danych wpłynie na&nbsp;poprawę efektywności zarządzania Państwa podmiotem. 
                                        Istotnym aspektem jest także możliwość uzyskania informacji o&nbsp;podstawowych wskaźnikach ekonomiczno-finansowych i&nbsp;statystycznych 
                                        oraz&nbsp;możliwość porównania ich&nbsp;wartości z&nbsp;innymi podmiotami.<br/>
                                    Aplikacja jest zaprojektowana tak, aby
                                        każdy użytkownik w&nbsp;prosty sposób wykorzystał w&nbsp;pełni jej&nbsp;funkcjonalność.
                                        Aplikacja będzie rozwijana zgodnie z&nbsp;potrzebami i&nbsp;sugestiami użytkowników, 
                                        stąd każda zgłoszona przez&nbsp;Państwa uwaga będzie cennym źródłem wiedzy dla&nbsp;udoskonalania narzędzia. ​</ListGroupItem>
                                    
                                    </ListGroup>

                                    <ListGroupItem  className='text-primary text-main' aria-label={'Dlaczego warto skorzystać z Aplikacji SRK?'} role={"button"} tabIndex={'0'} onClick={() => {
                                        setView('reasons')
                                    }}
                                                    onKeyDown={(e) => {
                                                        if (e.key === 'Enter') {
                                                            setView('reasons')
                                                        }
                                                    }}
                                    style={{textDecoration: 'none'}}>
                                            Dlaczego warto skorzystać z Aplikacji SRK?
                                    </ListGroupItem>
                                    <div className="text-right">
                                        <Button className="btn-round m-0" outline color="primary" style={{minWidth:'243px'}} onClick={()=>{openDemo()}}>Zobacz film instruktażowy</Button>
                                        <Button className="btn-round m-2" outline color="primary" style={{minWidth:'243px'}}  onClick={e=>downloadGuide()}>
                                        Pobierz instrukcję
                                        </Button>
                                    </div>
                                
                            </CardBody>
                        </Card>
                    </>}
                    {view === 'reasons' && <>
                        <Advantages getBackBtn={()=>getBackBtn()}  noCard={false}/>
                    </>}
                    <UnusedViews view={view} getBackBtn={()=>getBackBtn()} />
                </Col>
            </Row>
            <br/>
            {view === 'main' && <>
            <Row>
                    <Col className="ml-auto mr-auto text-center" md="12">
                        <div style={navigationButtons}>
                            <Link to={"/admin/import_five_four"} style={navigationDiv(containerColor.import)} className='darkColor'>
                                <i style={{alignSelf:'center', fontSize:"24px"}}  className="nc-icon nc-single-copy-04 my-3"  />
                                <div style={{alignSelf:'center',fontWeight:"normal"}}>Wprowadzanie danych</div>
                            </Link>
                            <Link to={"/admin/pricing_definition"} style={navigationDiv(containerColor.wycena)} className='darkColorWycena'>
                                <i className="nc-icon nc-money-coins my-3" style={{alignSelf:'center', fontSize:"24px"}} />
                                <div style={{alignSelf:'center',fontWeight:"normal"}}>Wycena procedur medycznych</div>
                            </Link>
                            <Link to={"/admin/raport"} style={navigationDiv(containerColor.raporty)} className='darkColorRaporty'>
                                <i className="nc-icon nc-paper my-3" style={{alignSelf:'center', fontSize:"24px"}}/>
                                <div style={{alignSelf:'center', fontWeight:"normal"}}>Raporty</div>
                            </Link>
                            <Link to={"/admin/management_dashboard"}  style={navigationDiv(containerColor.pulpit)} className='darkColorPulpit'>
                                <i className="nc-icon nc-briefcase-24 my-3" style={{alignSelf:'center', fontSize:"24px"}}/>
                               <div style={{alignSelf:'center', fontWeight:"normal"}}> Pulpit zarządczy</div>
                            </Link>
                            <Link to={"/admin/my_indicators"} style={navigationDiv(containerColor.wskazniki)} className='darkColorWzkazniki'>
                                <i className="nc-icon nc-chart-bar-32 my-3" style={{alignSelf:'center', fontSize:"24px"}}/>
                                <div style={{alignSelf:'center', fontWeight:"normal"}}>Wskaźniki</div>
                            </Link>
                        </div>
                    </Col>
                </Row> 
            </>}
        </div>
    )
}

const btnNewStyle = {
    float: 'right',
    margin: '0px !important'
}

const navigationButtons = {
    display: 'grid',
    gridTemplateColumns: 'repeat(5, 1fr)',
    gridColumnGap: '10px',
    justifyItems: 'stretch',
    alignItems: 'stretch',
    margin: 'auto',
    color: "white",
    height: '105px'
}

const navigationDiv = (colors) => {
    return {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        // justifyContent: 'center',
        // alignItems: 'center',
        color: "white",
        fontWeight: 'bold',
        textTransform: 'uppercase',
        background:  colors.dark ,
        borderRadius: '30px',
        padding: '0px 5px'
    }
}

const containerColor = {
    import: {
        dark: '#207893',
        light: '#66cef1' // '#58b2d1',
    },
    wycena: {
        dark: 'rgb(0, 107, 167)',
        light: '#c0f3ff'//'#e3f2f3',
    },
    raporty: {
        dark: '#266a64',
        light: '#b9ffff'//'#a3eff0',
    },
    wskazniki: {
        dark: 'rgb(31, 99, 119)',
        light: '#bbffff' //'#a2e9f0',
    },
    pulpit: {
        dark: 'rgb(73, 88, 176)',
        light: '#fffc3f' //'#ffe72b',
    }
}

export default MainPage
